import React from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Col,
  Row,
  Table,
  Label,
  Container,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import _ from "lodash";
import api from "../../api";
import utils from "../../resources/utils";
import FromNow from "../../components/Time/FromNow";
import "./index.css";
import SiteDropdownInput from "components/SiteDropdownInput";

const STATUS_FILTER = [
  { label: "All", value: "all" },
  { label: "Mới", value: "new" },
  { label: "Đang kiểm tra", value: "checking" },
  { label: "Xem lại sau", value: "saved-for-later" },
  { label: "Duyệt", value: "approved" },
  { label: "Từ chối", value: "rejected" }
];

// The Roster component matches one of two different routes
// depending on the full pathname
export default class ExternalSitesScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sites: [],
      siteCount: 0,
      pagesCount: 0,
      page: 0,
      limit: 15,
      isLoading: false,
      selectedStatus: STATUS_FILTER[0],
      selectedBrand: null,
      isShowModal: false,
      site: {
        external_status: STATUS_FILTER[2].value
      },
      brandList: [],
      labelNames: []
    };
    this.searchLocation = _.debounce(this.searchLocation, 500);
    this.updateAttr = this.updateAttr.bind(this);
  }
  UNSAFE_componentWillMount() {
    // this.getCurrentUser();
    this.searchLocation();
    this.getBrandList();
  }
  componentDidMount = () => {};
  getCurrentUser() {
    api.fetchAPI({
      method: "get",
      uri: `userme/me`,
      success: response => {
        if (response.result) {
          console.log(response.result);
          this.setState({
            currentUser: response.result
          });
        } else {
          alert("Failed to get user: " + response.msg);
        }
      },
      error: error => {
        console.error(error);
      }
    });
  }

  getBrandList() {
    api.fetchAPI({
      method: "get",
      uri: `brand/`,
      success: response => {
        if (response.result) {
          this.setState({
            brandList: response.result.map(item => {
              return {
                label: item.name,
                value: item
              };
            })
          });
        }
      },
      error: error => {
        console.error(error);
      }
    });
  }

  searchLocation() {
    this.getSites();
  }
  async getSites(pageNumber = 0) {
    await this.setState({ page: pageNumber });
    const {
      page,
      limit,
      selectedStatus,
      // searchKeyword,
      // searchName,
      // searchLocationType,
      searchBrandId
    } = this.state;
    let siteFilterString = "(col:is_active,opr:eq,value:1)";
    if (selectedStatus) {
      if (selectedStatus.value && selectedStatus.value !== "all") {
        siteFilterString =
          siteFilterString +
          `,(col:status,opr:eq,value:${selectedStatus.value})`;
      }
    }
    if (searchBrandId) {
      siteFilterString =
        siteFilterString + `,(col:brand,opr:rel_o_m,value:'${searchBrandId}')`;
    }
    api.fetchAPI({
      method: "get",
      uri: `external_site/?q=(page:${page},page_size:${limit},order_columns:created_on,order_direction:desc,filters:!(${siteFilterString}))`,
      success: response => {
        console.log(response.result);
        this.setState({
          sites: response.result,
          siteCount: response.count,
          pagesCount: Math.floor(response.count / limit) + 1
        });
        this.setState({ isLoading: false });
      },
      error: error => {
        console.error(error);
        this.setState({ isLoading: false });
      }
    });
  }
  updateAttr(attribute, value) {
    const { site } = this.state;
    if (value == "") value = null;
    site[attribute] = value;

    this.setState({ site }, () => {
      if (attribute == "location_type") {
        this.getBrandByLocationType(value);
      }
    });
  }
  render() {
    const {
      sites,
      pagesCount,
      statusFilter,
      selectedStatus,
      selectedBrand,
      searchKeyword,
      searchName,
      site,
      labelNames,
      searchLocationType,
      brandList,
      currentUser
    } = this.state;
    if (!sites) return null;
    return (
      <Container>
        <div className="page-container">
          <Row>
            <Col xs={12}>
              <h1>Mặt bằng bên ngoài</h1>
            </Col>
          </Row>
          <br />
          <div></div>
          <Row className="site-listing__filters">
            {/* <Col xs={12} sm={6} md={8}>
              <div>
                <Label>Chọn thương hiệu</Label>
                <Select
                  options={brandList}
                  value={selectedBrand}
                  placeholder="Chọn thương hiệu"
                  onChange={selectedOption => {
                    this.setState(
                      {
                        searchBrandId: selectedOption.value.id,
                        selectedBrand: selectedOption
                      },
                      this.searchLocation
                    );
                  }}
                />
              </div>
            </Col> */}
            <Col xs={12} sm={6} md={4}>
              <FormGroup>
                <Label>Status</Label>
                <Select
                  options={STATUS_FILTER}
                  value={statusFilter}
                  onChange={selectedOption =>
                    this.setState(
                      { selectedStatus: selectedOption, page: 0 },
                      this.getSites
                    )
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={12}>
              {pagesCount && pagesCount > 0 ? (
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={pagesCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  initialPage={0}
                  onPageChange={page => this.getSites(page.selected)}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              ) : null}
            </Col>
          </Row>
          <Table className="site-listing__tables">
            <thead>
              <tr>
                <th>Thương hiệu</th>
                <th>Địa chỉ</th>
                <th>Thành phố</th>
                <th>Tạo lúc</th>
                <th>Trạng thái</th>
              </tr>
            </thead>
            <tbody>
              {sites.map(site => (
                <tr key={site.id}>
                  <td>
                    {site && site.brand && site.brand.name
                      ? site.brand.name
                      : ""}
                  </td>
                  <td>
                    {site.brand && site.brand.brand_logo_image && (
                      <img
                        className="site-listing__brand-logo-img"
                        src={site.brand.brand_logo_image}
                        alt={site.brand}
                      />
                    )}
                    <Link to={`/external_site/${site.id}`}>
                      <span>
                        {site.address_number} {site.street_name}{" "}
                        {site.ward_name}
                      </span>
                    </Link>
                  </td>
                  <td>{site.city && site.city.name}</td>
                  <td>
                    <FromNow value={site.created_on} />
                  </td>
                  <td>
                    {site.status && (
                      <span
                        className={`site-status-label ${site.external_status}`}
                      >
                        {site.status}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="site-listing__cards">
            <Row>
              {sites.map(site => (
                <Col xs={12} key={site.id} className="site-listing__card">
                  <div className="site-listing__content">
                    <p>
                      {site.brand && site.brand.brand_logo_image && (
                        <img
                          className="site-listing__brand-logo-img"
                          src={site.brand.brand_logo_image}
                          alt={site.brand}
                        />
                      )}
                      <span
                        className={`site-status-label ${site.site_dev_status}`}
                      >
                        {site.site_dev_status}
                      </span>
                    </p>
                    <Link
                      to={`/market_information/${site.id}`}
                      className="site-listing__card-address"
                    >
                      {site.address ? (
                        <span>{site.address}</span>
                      ) : (
                        <span>{site.full_address}</span>
                      )}
                    </Link>
                    <p className="site-listing__card-since">
                      <span className="site-listing__card-creator">
                        {site.created_by.first_name} {site.created_by.last_name}
                      </span>
                      <FromNow value={site.created_on} />
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </Container>
    );
  }
}
